<template>
  <!-- 分词管理 -->
    <operateButton @btn-handle="btnHandle" @btn-in-table="btnInTable"
        :style="btnLeftList.length > 0 ? '' : 'display:block;'" @btn-on-left="btnOnList" />
  <el-button-group v-if="false">
    <el-button type="primary" size="large" @click="addFnc($event)"
      ><el-icon><Plus /></el-icon>添加</el-button
    >
  </el-button-group>

  <!-- 表格组件 -->
  <TableList
    componentTableId="ParticipleManagement"
    @update-list="updateList"
    excelName="分词管理"
    :table-data="tableData"
    :header-data="headerData"
    :table-height="
        btnLeftList.length > 0 ? tableMaxHeight : tableMaxHeight + 40
      "
    :loading="loading"
    :loading-text="loadingText"
    :empty-text="emptyText"
    @handleEdit="editFnc"
    @handleDelete="deleteFnc"
    @searchFnc="searchFnc"
    @openContent="openContent"
    @handleSelection="handleSelection"
  >
     <!-- 列表按钮操作动态 -->
      <template #inTableCustom="scope">
        <div class="optionDiv" style="white-space: nowrap; display: inline-block; float: left">
          <el-button-group style="display: flex" v-if="buttonList && buttonList.length > 1">
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </el-button-group>
          <div v-else>
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </div>
        </div>
      </template>
    <template #majorsCustom="scope">
      <span
        class="hand blue"
        v-if="scope.scope.majors && scope.scope.majors.length > 0"
        @click="openReleve(scope.scope)"
      >
        已关联{{ scope.scope.majors.length }}个专业</span
      >
      <span v-else class="hand blue" @click="openReleve(scope.scope)"
        >设置关联</span
      >
    </template>
  </TableList>
  <!-- 底部工具 -->
  <Pagination
    :pagination="pagination"
    :is-loading="loading"
    @change-pagination="changePagination"
  >
  </Pagination>
  <!-- 添加编辑 分词管理 -->
  <el-dialog
    class="dialogNoPadding"
    :close-on-click-modal="false"
    v-model="addEditVisible"
    :title="dialogTitle"
    width="650px"
    draggable
                destroy-on-close
  >
    <AddEditParticiple
      v-if="addEditVisible"
      :edit-obj="editObj"
      :is-edit="isEdit"
      @close-dialog="closeDialog"
      @update-list="updateList"
    ></AddEditParticiple>
  </el-dialog>
</template>

<script>
import TableList from "@/components/TableHeaderCom/index.vue";
import Pagination from "components/Pagination.vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { lostFocus } from "common/utils";
import { reactive, onMounted, toRefs, computed, toRaw,h, nextTick,ref } from "vue";
import { getList, del } from "network/participleManagement.js";
import AddEditParticiple from "views/participleManagement/AddEditParticiple.vue";
import store from "../../store/index";
export default {
  name: "ParticipleManagement",
  props: {
    tableMaxHeight: Number,
  },
  components: {
    TableList,
    Pagination,
    AddEditParticiple,
  },
  setup() {
    //这里定义一个结构体，用来保存项目信息
    const data = reactive({
      isDelect: computed(() => {
        return (
          store.state.isDelect ||
          JSON.parse(sessionStorage.getItem("isDelect"))
        );
      }),
      tableData: [],
      //表格数据
      tableData: [],
      multipleSelection:[],
      //表头数据
      headerData: [
        {
          label: "勾选框",
          type: "selection",
          width: "55",
          fixed: "left",
        },{
          label: "分词",
          prop: "words",
          minwidth: "300",
          align: "left",
          noSetText: "未设置",
          type: "InputSearch",
          fixed: "left",
        },
        {
          label: "替代词分词",
          prop: "replaceWords",
          minwidth: "300",
          align: "left",
          noSetText: "未设置",
          type: "InputSearch",
          fixed: "left",
        },
        {
          label: "PC端URL",
          prop: "pcUrl",
          minwidth: "300",
          align: "center",
          noSetText: "未设置",
          linkJump: true,
        },
        {
          label: "移动端URL",
          prop: "mobileUrl",
          minwidth: "300",
          align: "center",
          noSetText: "未设置",
          linkJump: true,
        },
        {
          label: "排序值",
          prop: "orderIndex",
          width: "100",
          align: "center",
          noSetText: "未设置",
                  },
        
      ],
      // 表格是否在加载中
      loading: true,
      loadingText: "加载中...",
      emptyText: "暂无数据",
      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      //筛选项
      search: {
        words: "", //筛选 分词
        replaceWords: "", //筛选 替代词
      },
      dialogTitle: "添加分词",
      addEditVisible: false, //添加编辑弹窗
      editObj: {},
      isEdit: false, //是否是编辑
    });

    //挂载后调用函数获取项目数据
    onMounted(() => {
      geListData(); //请求分词列表数据
    });

    // 获取列表
    const geListData = (type) => {
      data.loading = true;
      const obj = {
        words: data.search.words,
        replaceWords: data.search.replaceWords,
        pageIndex: data.pagination.currentPage,
        pageSize: data.pagination.pageSize,
      };
      getList(obj)
        .then((result) => {
          
          if (result && result.code == 1) {
            data.pagination.total = result.result.totalCount;
            data.tableData = result.result.rows;
            data.loading = false;
          } else {
            data.loading = false;
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    // 搜索
    const searchFnc = (val) => {
      if (val.prop && val.prop == "words") {
        data.search.words = val.value;
      }
      if (val.prop && val.prop == "replaceWords") {
        data.search.replaceWords = val.value;
      }
      data.pagination.currentPage = 1;
      geListData();
    };

    //更新列表
    const updateList = () => {
      geListData();
    };

    //关闭弹窗
    const closeDialog = () => {
      data.addEditVisible = false;
    };

    // 添加
    const addFnc = (e) => {
      data.addEditVisible = true;
      data.dialogTitle = "添加分词";
      data.editObj = {};
      data.isEdit = false;
    };

    // 编辑分词
    const editFnc = (obj) => {
      data.addEditVisible = true;
      data.dialogTitle = `编辑【${data.multipleSelection[0].words}】分词`;
      data.editObj = data.multipleSelection[0];
      data.isEdit = true;
    };

    // 删除
    const deleteFnc = (obj) => {
          ElMessageBox({
        title: "删除",
        message: h("p", null, [
          h("span", null, "是否删除【"),
          h(
            "b",
            { style: "color: #fd5252;font-size:16px;" },
            `${data.multipleSelection[0].words}`
          ),
          h("span", null, "】分词？ "),
        ]),
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确认",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            // 开启按钮加载
            instance.confirmButtonLoading = true
            instance.confirmButtonText = "确认中"
            // 删除接口
            del(data.multipleSelection[0].id)
            .then((result) => {
              if (result && result.code == 1) {
                done();
                ElMessage.success(result.message);
                updateList();
              } else {
                done();
                ElMessage.error(result.message);
              }
            })
            .catch((err) => {
              done();
              ElMessage.error(err.message);
            })
          } else {
            done();
          }
        },
      })
        // .then(() => {
        //   deleteData(obj.id);
        // })
        .catch(() => {
          ElMessage("取消删除");
        });
    };
    function deleteData(id) {
      del(id)
        .then((result) => {
          
          if (result && result.code == 1) {
            ElMessage.success(result.message);
            updateList();
          } else {
            ElMessage.error(result.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // 分页
    const changePagination = (val) => {
      data.pagination = toRaw(val);
      updateList();
    };
// 表格多选行处理
const handleSelection = (row) => {
  data.multipleSelection = JSON.parse(JSON.stringify(row));
};
const doEvent = function (btn, row) {
  try {
    data.multipleSelection = [];
    data.multipleSelection.push(row);
    eval(btn.split("(")[0] + `()`);
  }
  catch (err) {
    console.log(err);
    
    ElMessageBox.alert("err");
  }
}
    const btnHandle = (val) => {
      try {
        eval(val);
      } catch (error) {
        ElMessage.error("按钮事件不存在");
      }
    };
    const btnLeftList = ref([]);
    const buttonList = ref([]);
    const btnOnList = (val) => {
      btnLeftList.value = val ? val : [];
    }
    const btnInTable = async (val) => {
      if (val?.length > 0) {
        // 先设置按钮数据并插入列定义
        buttonList.value = val;
        data.headerData.splice(1, 0, {
          label: "操作",
          prop: "inTable",
          align: "center",
          fixed: "left",
          custom: true,
          isInTable: true,
        });
        // 等待 DOM 更新，确保表格单元格渲染完毕以便正确测量宽度
        await nextTick();
        await nextTick();
        // 获取操作按钮组的元素并测量宽度
        const opts = document.getElementsByClassName("optionDiv");
        let widthArr = [];
        Array.prototype.forEach.call(opts, function (item) {
          if (item.offsetWidth > 0) {
            widthArr.push(item.offsetWidth);
          }
        });
        if (widthArr.length > 0 && buttonList.value?.length > 0) {
          let index = 0;
          var obj = {};
          for (var i = 0; i < data.headerData.length; i++) {
            if (data.headerData[i].label == "操作") {
              index = i;
              obj = JSON.parse(JSON.stringify(data.headerData[i]));
              // 使用数字类型宽度（px由组件处理），并留出一定内边距
              obj.width = Math.max(...widthArr) + 24;
            }
          }
          data.headerData[index] = obj;
        }
      }
    };
    return {
      //解构Data结构体，让模板可以直接调用Data里面的对象
      ...toRefs(data),
      geListData,
      searchFnc,
      updateList,
      closeDialog,
      addFnc,
      editFnc,
      deleteFnc,
      changePagination,
      handleSelection,
      btnInTable,
      btnLeftList,
      buttonList,
      btnOnList,
      btnHandle,
      doEvent,
    };
  },
};
</script>
<style scoped>
</style>